import { portfolioColumnActionType } from '../../constants';

const portfoliosColumnReducer = (state = [], action) => {
    switch (action.type) {
        case portfolioColumnActionType.FETCH_PORTFOLIOS_COLUMN:
            return action.payload;
        default:
            return state;
    }
};
export default portfoliosColumnReducer